import { createContext, useContext } from "react";

const CheckoutContext = createContext();

const useCheckoutContext = () => useContext(CheckoutContext);

export { CheckoutContext, useCheckoutContext };